module.exports = __webpack_public_path__ + "static/fonts/icomoon.16666c7e.ttf";